import _ from 'underscore';
import React from 'react';
import BootstrapData from 'models/BootstrapData';
import FeatureToggleUtils from 'FeatureToggleUtils';
import Global from 'models/Global';
import {renderReactComponentWithRedux} from '../hocs/withReduxProvider';
import RenderedView from './RenderedView';
import Backbone from 'backbone';
import PrivateEventLoginScreen from './PrivateEventLoginScreen';

const PrivateEventPageView = Backbone.View.extend({
    events: { },
    initialize: function(options) {
        options = options || {};
        FeatureToggleUtils.mergeFeatureToggleWithConfig();
        this.bootstrapData = options.bootstrapData;
        RenderedView.prototype.initialize.apply(this, arguments);
        Global.set('page', 'privateEvent');
        this.reactRoot = document.querySelector('#privateEvent-container');
        if (this.reactRoot) {
            this.render();
        }
    },
    render() {
        renderReactComponentWithRedux(
            PrivateEventLoginScreen,
            this.reactRoot,
            {
                pageReferer: this?.bootstrapData?.pageReferer,
                event: this.bootstrapData.event,
            }
        );
    },
});

const event = BootstrapData('bootstrap-data-event');
const config = BootstrapData('bootstrap-data-config');
const loginSettings = BootstrapData('bootstrap-data-loginSettings');
const siteConf = BootstrapData('bootstrap-data-siteConf');
const pageReferer = BootstrapData('bootstrap-data-pageReferer');

export default new PrivateEventPageView({
    el: $(document.body),
    bootstrapData: {
        event,
        eventID: event.id,
        loginSettings,
        siteConf,
        config,
        pageReferer,
    }
});

